import { ICompanyState, initialCompanyState } from '../state/company.state';
import { CompanyActions, ECompanyActions } from '../actions/company.action';

export function companyReducers(state = initialCompanyState, action: CompanyActions): ICompanyState {
    // export function userReducers = (state = initialUserState, action: UserActions): IUserState => {
    switch (action.type) {
      
        case ECompanyActions.CreateCompanySuccess: {
            return {
                ...state,
                createSuccess: action.payload,
                createError: null
            };
        }
        case ECompanyActions.CreateCompanyError: {
            return {
                ...state,
                createError: action.payload,
                createSuccess: null
            };
        }
        case ECompanyActions.GetAllCompaniesSuccess: {
            return {
                ...state,
                getAllcompanies: action.payload,
                getAllcompaniesError: null
            }
        }
        case ECompanyActions.GetAllCompaniesErrorMessage: {
            return {
                ...state,
                getAllcompaniesError: action.payload,
                getAllcompanies: null
            }
        }
        case ECompanyActions.EditCompanySuccess: {
            return {
                ...state,
                editCompanySuccess: action.payload,
                editCompanyError: null
            }
        }
        case ECompanyActions.EditCompanyError: {
            return {
                ...state,
                editCompanyError: action.payload,
                editCompanySuccess: null
            }
        }
        case ECompanyActions.ConvertToActiveSuccess: {
            return { ...state, convertToActiveSuccess: action.payload };
        }
        case ECompanyActions.ConvertToActiveError: {
            return { ...state, convertToActiveError: action.payload };
        }
        case ECompanyActions.RenewLicenseDateSuccess: {
            return {
                ...state,
                renewLicenseDateSuccess: action.payload,
                renewLicenseDateError: null
            }
        }
        case ECompanyActions.RenewLicenseDateError: {
            return {
                ...state,
        
                renewLicenseDateError: action.payload,
                renewLicenseDateSuccess: null
                
            }
        }
        case ECompanyActions.GiveExtensionDateSuccess: {
            return {
                ...state,
                giveExtensionDateSuccess: action.payload,
                giveExtensionDateError: null
            }
        }
        case ECompanyActions.GiveExtensionDateError: {
            return {
                ...state,
                giveExtensionDateError: action.payload,
                giveExtensionDateSuccess: null
            }
        }
        case ECompanyActions.GetInactivateCmpySuccess: {
            return {
                ...state,
                getInactivateCmpySuccess: action.payload,
                getInactivateCmpyError: null
            }
        }
        case ECompanyActions.GetInactivateCmpyError: {
            return {
                ...state,
                getInactivateCmpyError: action.payload,
                getInactivateCmpySuccess: null
            }
        }
        case ECompanyActions.GetActivateCmpySuccess: {
            return {
                ...state,
                getActivateCmpySuccess: action.payload,
                getActivateCmpyError: null
            }
        }
        case ECompanyActions.GetActivateCmpyError: {
            return {
                ...state,
                getActivateCmpyError: action.payload,
                getActivateCmpySuccess: null
            }
        }
        case ECompanyActions.GetCompanyByIdSuccess: {
            return {
                ...state,
               getCompanyByIdSuccess: action.payload,
               getCompanyByIdError: null
            }
        }
        case ECompanyActions.GetCompanyByIdError: {
            return {
                ...state,
                getCompanyByIdError: action.payload,
                getCompanyByIdSuccess: null
            }
        }
        case ECompanyActions.GetCompanyLicenseSuccess: {
            return {
                ...state,
               getCompanyLicenseSuccess: action.payload,
               getCompanyLicenseError: null
            }
        }
        case ECompanyActions.GetCompanyLicenseError: {
            return {
                ...state,
                getCompanyLicenseError: action.payload,
                getCompanyLicenseSuccess: null
            }
        }
        case ECompanyActions.GetUsersCountSuccess: {
            return {
                ...state,
               getUsersCountSuccess: action.payload,
               getUsersCountError: null
            }
        }
        case ECompanyActions.GetUsersCountError: {
            return {
                ...state,
                getUsersCountError: action.payload,
                getUsersCountSuccess: null
            }
        }
        case ECompanyActions.GetAllUsersSuccess: {
            return {
                ...state,
               getAllUsersSuccess: action.payload,
               getAllUsersError: null
            }
        }
        case ECompanyActions.GetAllUsersError: {
            return {
                ...state,
                getAllUsersError: action.payload,
                getAllUsersSuccess: null
            }
        }

        
        default:
            return state;
    }
}

